export default {
  title: 'The kitchen received your items',
  description: 'Don’t forget to close out your check & pay at the end of your meal.',
  buttons: {
    okay: 'Okay',
  },
};
